var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.staticPgMap && _vm.staticPgMap.cn)?_c('div',{staticClass:"tiny",domProps:{"innerHTML":_vm._s(_vm.staticPgMap.cn)},on:{"click":_vm.handleLineClick}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }